"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickbooksCallbackPayloadStateSchema = exports.IntuitSsoCallbackPayloadStateSchema = exports.QuickbooksDataLinkingCallbackPayloadStateSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const types_utils_1 = require("../../types.utils");
const base_callback_state_interface_1 = require("./base-callback-state.interface");
exports.QuickbooksDataLinkingCallbackPayloadStateSchema = zod_1.default.object({
    ...base_callback_state_interface_1.BaseCallbackPayloadState,
    isSso: zod_1.default.literal(false),
});
exports.IntuitSsoCallbackPayloadStateSchema = zod_1.default.object({
    successRedirectUrl: types_utils_1.stringSchema,
    errorRedirectUrl: types_utils_1.stringSchema,
    isSso: zod_1.default.literal(true),
});
exports.QuickbooksCallbackPayloadStateSchema = zod_1.default.union([
    exports.QuickbooksDataLinkingCallbackPayloadStateSchema,
    exports.IntuitSsoCallbackPayloadStateSchema,
]);
